import styled from "styled-components";
import { Box, Flex, Text } from "rebass/styled-components";

export const ModalContainer = styled(Box)`
  background: ${({ theme }) => theme.colors.navy600};
  border-radius: 16px;
  max-width: 500px;
  width: 90vw;
`;

export const ModalHeader = styled(Flex)`
  align-items: flex-start;
  border-bottom: 1px solid ${({ theme }) => theme.colors.navy50};
  justify-content: space-between;
  padding: 20px 24px;
`;

export const HeaderTitle = styled(Text)`
  color: ${({ theme }) => theme.colors.ice};
  font-family: Barlow;
  font-size: 20px;
  font-weight: 600;
`;

export const HeaderSubtitle = styled(Text)`
  color: ${({ theme }) => theme.colors.shade300};
  font-family: Barlow;
  font-size: 14px;
  line-height: 1.4;
  padding-top: 4px;
`;

export const CloseButton = styled.button`
  align-items: center;
  background: none;
  border: none;
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.shade400};
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
  height: 32px;
  justify-content: center;
  transition: all 0.15s ease;
  width: 32px;

  &:hover {
    background: ${({ theme }) => theme.colors.navy50};
    color: ${({ theme }) => theme.colors.ice};
  }
`;

export const ModalBody = styled(Box)`
  padding: 24px;
`;

export const OptionCard = styled(Flex)`
  align-items: center;
  background: ${({ theme }) => theme.colors.navy400};
  border: 1px solid ${({ theme }) => theme.colors.navy100};
  border-radius: 10px;
  cursor: pointer;
  gap: 16px;
  padding: 16px;
  transition: all 0.15s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.navy500};
    border-color: ${({ theme }) => theme.colors.envy};
  }
`;

export const OptionIconWrapper = styled(Flex)`
  align-items: center;
  background: ${({ theme }) => theme.colors.navy300};
  border-radius: 50%;
  color: ${({ theme }) => theme.colors.ice};
  flex-shrink: 0;
  height: 40px;
  justify-content: center;
  width: 40px;
`;

export const OptionTitle = styled(Text)`
  color: ${({ theme }) => theme.colors.ice};
  font-family: Barlow;
  font-size: 15px;
  font-weight: 600;
`;

export const OptionDescription = styled(Text)`
  color: ${({ theme }) => theme.colors.chalk};
  font-family: Barlow;
  font-size: 13px;
  line-height: 1.4;
`;

export const OptionsContainer = styled(Flex)`
  flex-direction: column;
  gap: 12px;
`;

export const StepRow = styled(Flex)`
  align-items: flex-start;
  gap: 14px;

  & + & {
    margin-top: 20px;
  }
`;

export const StepNumber = styled(Flex)`
  align-items: center;
  background: ${({ theme }) => theme.colors.navy300};
  border-radius: 50%;
  color: ${({ theme }) => theme.colors.ice};
  flex-shrink: 0;
  font-family: Barlow;
  font-size: 14px;
  font-weight: 700;
  height: 28px;
  justify-content: center;
  width: 28px;
`;

export const StepLabel = styled(Text)`
  color: ${({ theme }) => theme.colors.ice};
  font-family: Barlow;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 10px;
`;

export const DiscordButton = styled.button`
  align-items: center;
  background: ${({ theme }) => theme.colors.discord};
  border: none;
  border-radius: 8px;
  box-sizing: border-box;
  color: ${({ theme }) => theme.colors.ice};
  cursor: pointer;
  display: flex;
  font-family: Barlow;
  font-size: 14px;
  font-weight: 600;
  gap: 8px;
  justify-content: center;
  padding: 11px 16px;
  transition: opacity 0.15s ease;
  width: 100%;

  &:hover {
    opacity: 0.9;
  }
`;

export const HandleInput = styled.input`
  background: ${({ theme }) => theme.colors.navy};
  border: 1px solid ${({ theme }) => theme.colors.navy100};
  border-radius: 8px;
  box-sizing: border-box;
  color: ${({ theme }) => theme.colors.ice};
  font-family: Barlow;
  font-size: 14px;
  padding: 11px 12px;
  width: 100%;

  &::placeholder {
    color: ${({ theme }) => theme.colors.shade400};
  }

  &:focus {
    border-color: ${({ theme }) => theme.colors.envy};
    outline: none;
  }
`;

export const HelperText = styled(Text)`
  color: ${({ theme }) => theme.colors.shade300};
  font-family: Barlow;
  font-size: 13px;
  line-height: 1.4;
  margin-top: 6px;
`;

export const ConfirmCheck = styled(Flex)`
  align-items: center;
  color: ${({ theme }) => theme.colors.envy};
  justify-content: center;
  padding: 12px 0;
`;

export const ModalFooter = styled(Flex)`
  border-top: 1px solid ${({ theme }) => theme.colors.navy200};
  flex-direction: column;
  gap: 12px;
  padding: 16px 24px;
`;

export const PrimaryButton = styled.button`
  background: ${({ theme }) => theme.colors.envy};
  border: none;
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.ice};
  cursor: pointer;
  font-family: Barlow;
  font-size: 14px;
  font-weight: 600;
  padding: 12px 24px;
  transition: opacity 0.15s ease;
  width: 100%;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const SkipButton = styled.button`
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.colors.shade400};
  cursor: pointer;
  font-family: Barlow;
  font-size: 13px;
  padding: 8px;
  text-align: center;
  transition: color 0.15s ease;

  &:hover {
    color: ${({ theme }) => theme.colors.shade200};
  }
`;
